export const makeFirstLetterUppercase  = (txt) => {
try {
    txt = txt.split(" ")
    txt = txt.map((wrd)=>{
        wrd = wrd.split("")
        wrd[0]=wrd[0].toUpperCase()
        return wrd.join("")
    })
    txt =  txt.join(" ")
    return txt
} catch (error) {
    return txt
}
    
}  